(function () {
  function initStickyMedia() {
    if (window.innerWidth < 990) return;

    const mediaEl = document.querySelector('product-images.product__images');
    const divider = document.querySelector('.product__block--divider');

    if (!mediaEl || !divider) return;

    function onScroll() {
      if (window.innerWidth < 990) {
        mediaEl.classList.remove('is-unsticky');
        return;
      }
      const mediaBottom = mediaEl.getBoundingClientRect().bottom;
      const dividerTop  = divider.getBoundingClientRect().top;

      if (mediaBottom >= dividerTop) {
        mediaEl.classList.add('is-unsticky');
      } else {
        mediaEl.classList.remove('is-unsticky');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll(); // 初始化检查
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyMedia);
  } else {
    initStickyMedia();
  }
})();
